module.exports = __webpack_public_path__ + "img/products_big_can_ultimateusa.606cf944.png";